import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import { Building } from '../../model/Building';
import { ApiDate } from '../../realty/model/ApiDate';

export function init(tag: any): void {
  const onModelDataUpdate = () => {
    map(DataStore.getBuildings(), tag);
    tag.update();
  };
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.year = (date: ApiDate) => {
    if (date && date.ddmmyyyy) {
      return date.ddmmyyyy.split('-')[1];
    }
  };
}

function map(buildings: Building[], tag: any): void {
  const residentialBuildings: Building[] = [];
  const nonResidentialBuildings: Building[] = [];
  buildings.forEach((building: Building) => {
    if (building.isResidential) {
      residentialBuildings.push(building);
    } else {
      nonResidentialBuildings.push(building);
    }
  });
  tag.residentialBuildings = residentialBuildings;
  tag.nonResidentialBuildings = nonResidentialBuildings;
}



/** WEBPACK FOOTER **
 ** ./src/components/buildingDisplay/BuildingDisplayMapper.ts
 **/